import { ConsumerPortalDashboard } from "features/consumerPortalDashboard";

function DashboardPage() {
  return <ConsumerPortalDashboard />;
}

export default DashboardPage;
